export default __webpack_public_path__ + "static/media/limb_cube.151e1d14.jpg";